import styled from "styled-components";
import { Color, ColorDark, Font, breakpoints } from "@/shared/Constants";

export const CompatibilityLisContainer = styled.div`
  margin: 0 auto;
  padding-bottom: 20px;
  border-top: 1px solid ${Color.greySeparator};
  margin-top: 60px;
  ${breakpoints.phone} {
    margin-top: 20px;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-top: 1px solid ${ColorDark.greySeparator};
    }
  }
  &::before {
    content: "";
    height: 1px;
    width: 100%;
    background: ${Color.greySeparator};
    display: block;
    margin: 5px 0;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background: ${ColorDark.greySeparator};
      }
    }
  }

  h2 {
    ${Font.sansBold}
    font-size: 20px;
    color: ${Color.black000};
    margin: 20px 0;
    ${breakpoints.phone} {
      font-size: 18px;
      line-height: 19px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }

  .compatibility-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 34px 12px;
    ${breakpoints.phone} {
      grid-template-columns: repeat(1, 1fr);
      gap: 15px;
    }
  }

  .compatibility-link {
  }
  .compatibility-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: ${Color.greyF5F5F5};
    padding: 5px 8px;
    border-radius: 50px;
    transition: transform 0.2s ease-in-out;
    color: ${Color.secondaryBlack};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.darkGrey};
      }
    }
    span {
      ${Font.sansLight}
      font-size: 18px;
      line-height: 24px;
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }

  .compatibility-item img {
    width: 50px;
    height: 50px;
  }
`;
